import React from 'react';
import ArrivalsTable from './ArrivalsTable';
import DeparturesTable from './DeparturesTable';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col col-sm-12 col-md-6">
              <div className="box">
                <div className="box-header"><h3><i className="fas fa-sign-in"></i> Arrivals</h3></div>
                <div className="box-body">
                  <ArrivalsTable />
                </div>
              </div>
            </div>
            <div className="col col-sm-12 col-md-6">
              <div className="box">
                <div className="box-header"><h3><i className="fas fa-sign-out"></i> Departures</h3></div>
                <div className="box-body">
                  <DeparturesTable />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Listing;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/arrivals-departures/containers/Listing.jsx